import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";

import WithClickCount from "../../look/hocs/withClickCount";
import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {setWizardSelectedValues} from "../../../actions/wizardFunctions";
import {getFeatureGroupFromWizardGroup} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import MaterialsWizardSqftButton from "../../qkbPages/materialsWizard/materialsWizardSqftButton";
import {getWizardFeatureAsync} from "../../look/lookNavigation/lookMain/lookWizard/wizardFunctionsCommon";
import {getWizardCustomImageUrl} from "../../../misc/utils";
import {createModalFixSnapshot} from "../../sqft/components/popup/modalFix/CompatibilityWarnings/modalFixHelper";
import {storeSnapshot} from "../../../actions/sqftModalFunctions";
import {checkIfLookFeaturesReceived} from "../../../api/look-api";
import {getCurrentLayout} from "../../appLayout";
import {
  runWhileRoomSwitching,
  shouldSwitchRoom,
  switchRoomByWizardGroup,
  zoomToClickOnLogicFeatureAfterRoomSwitch
} from "../../visComponents/navigation/roomSwitchingFunctions";

const SelectionGridWizardGroupItem = (props) => {

  const {wizardGroup, wizardActiveStep, setWizardSelectedValues, wizardSelectedValues, styles, isRowItem,
    handleFeatureClick, storeSnapshot, isModalFixOpen} = props;

  const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);

  // const {customImageUrl, uploadedImageUrl} = wizardGroup;

  const isActive = wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].wizardGroup
    && wizardSelectedValues[wizardActiveStep].wizardGroup.id === wizardGroup.id;

  const wizardItemClick = async (maxClickCountReached) => {
    // Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookWizardParent + Analytics.getStringForAnalytics(wizardGroup.groupName));

    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    // const layout = getCurrentLayout();
    // const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
    // if (featureGroup && featureGroup.activeFeature) {
    //   if (featureGroup.partId === "vanity_sink" && wizardGroup.productCartTitle
    //     && wizardGroup.productCartTitle.includes("edestal") && featureGroup.getParent().vanity_type) {
    //     const navItems = layout.designNavigationItems({part: featureGroup});
    //     const nextPedestal = navItems.find(navItem => Array.isArray(navItem.part.metaData["MountType"]) && navItem.part.metaData["MountType"].includes("ST"));
    //     if (nextPedestal) {
    //       navFeatureCLick(nextPedestal.part);
    //     } else {
    //       navFeatureCLick(featureGroup.activeFeature);
    //     }
    //   }
    //   navFeatureCLick(featureGroup.activeFeature);
    // }

    if (!isModalFixOpen) {
      const snapshot = createModalFixSnapshot();
      storeSnapshot(snapshot);
    }

    setWizardSelectedValues({
      [wizardActiveStep]: {
        wizardGroup,
        partId: featureGroup ? featureGroup.partId : ""
      }
    });
    console.log("wizardGroupwizardGroup", wizardGroup);
    const switchAndClick = async () => {
      const roomSwitched = await switchRoomByWizardGroup(wizardGroup); // clickOnRoomLogic, waits until the new room is applied
      if (wizardGroup.clickOnLogic && wizardGroup.clickOnLogic.enabled && wizardGroup.clickOnLogic.feature
        && wizardGroup.clickOnLogic.groupName && handleFeatureClick) {
        const featureFound = await getWizardFeatureAsync(wizardGroup.clickOnLogic.feature, wizardGroup.clickOnLogic.groupName);
        console.log("clickOnLogic featureFound", featureFound);
        if (featureFound) {
          if ((document.kvConfig.visualizerType === "bvScene") && featureFound.partId === "walk_in_tub") {
            const layout = getCurrentLayout();
            if (layout.parts["Shower"]?.showerInteriorWall && !layout.parts["Shower"].showerInteriorWall.allFeaturesReceived) {
              await checkIfLookFeaturesReceived(layout.parts["Shower"].showerInteriorWall)
            }
          }
          await handleFeatureClick({part: featureFound}, null, wizardGroup.clickOnLogic);
          // the room was switched - zoom to the clicked feature group, not to the wizard step one
          zoomToClickOnLogicFeatureAfterRoomSwitch(wizardGroup, featureFound, roomSwitched);
        }
      }
    };
    // clickOnRoomLogic: hide not compatible / not in visualizer views on the canvas until the clickOnLogic feature is set
    if (shouldSwitchRoom(wizardGroup)) {
      await runWhileRoomSwitching(switchAndClick);
    } else {
      await switchAndClick();
    }
  }

  return (
    <WithClickCount>
      {(maxClickCountReached) => isRowItem ? (
        <div className="m-item" onClick={() => wizardItemClick(maxClickCountReached)}>
          <div className={"m-item__thumbnail" + (isActive ? " m-item__thumbnail--selected"  : "")}>
            {wizardGroup.customImageUrl ? (
              <div className="feature-thumbnail">
                <img className={"feature-thumbnail__image"} src={getWizardCustomImageUrl(wizardGroup.customImageUrl)} alt=""/>
              </div>
            ) : null}
          </div>
          <div className="m-item__content">
            <h2 className="product-info__title bold">{wizardGroup.productCartTitle || wizardGroup.title || wizardGroup.groupName}</h2>
            <div className="product-info__description">{wizardGroup.productCartDescription}</div>
            {window.location.href.includes("porcelanosa") && wizardGroup.id === "29" ? ( // && wizardGroup.title === "Xtone Underlayment" // removed, they can rename
              <div className="product-info__description">
                <MaterialsWizardSqftButton/>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className={"feature" + (isActive ? " feature--selected" : "")} // feature--stone // add it when dashboard is ready
             style={styles}
             onClick={() => wizardItemClick(maxClickCountReached)}>
          <div className="feature-thumbnail">
            {wizardGroup.customImageUrl
              ? <img className={"feature-thumbnail__image"}
                     src={getWizardCustomImageUrl(wizardGroup.customImageUrl)}
                     alt=""/>
              : null}
          </div>
          <div className={"feature-text"}>
            {/*{showPrice ? (*/}
            {/*  <span className="feature-text__price">*/}
            {/*  {getPriceWithIncluded(price, currentFeature.part, fabricatorData, intl.messages)}
            {/*</span>*/}
            {/*) : null}*/}
            <span className="feature-text__name">
              {wizardGroup.productCartTitle || wizardGroup.title || wizardGroup.groupName}
            </span>
          </div>
        </div>
      )}
    </WithClickCount>
  )
}

SelectionGridWizardGroupItem.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  isRowItem: PropTypes.bool,
  handleFeatureClick: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;
  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    isModalFixOpen: store.sqftModalFixState.isModalFixOpen,
  };
};

const mapDispatchToProps = {
  setWizardSelectedValues,
  storeSnapshot,
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectionGridWizardGroupItem);
